// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3zbOW","label":"LabeledBox_label__2dV7O"};